// removed by extract-text-webpack-plugin
module.exports = {"overlay":"style__overlay___2ZURW","overlayModal":"style__overlayModal___1a4XS","overlayModalInner":"style__overlayModalInner___1Kts8","overlayCloseButton":"style__overlayCloseButton___zDGWm","overlayModalTitle":"style__overlayModalTitle___15MUC","overlayModalText":"style__overlayModalText___khDec","overlayModalTextBold":"style__overlayModalTextBold___3YVhs","overlayModalButtons":"style__overlayModalButtons___2gym7","overlayModalButtonsItem":"style__overlayModalButtonsItem____1zla","overlayModalButtonsItemButton":"style__overlayModalButtonsItemButton___3kaeP","buttonActive":"style__buttonActive___sOObL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modal-video/style.css
// module id = 330
// module chunks = 0